var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullheight"},[(_vm.inputWriteable === _vm.canInput)?_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.save}},[_vm._v("保存")]):_vm._e(),_c('div',{attrs:{"id":"office"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }